import React from "react";
import { Box } from "@mui/material";
import warehouse from "../../../shared/assets/images/warehouse.png";
import GlobalSearch from "../../../shared/components/GlobalSearch";
import useTranslation from "../../../shared/hooks/useTranslation";

const EmptySearchAndBuy = () => {
  const { translate } = useTranslation("marketplace");
  return (
    <Box className="w-full h-full relative">
      <Box
        className="absolute inset-0"
        sx={{
          background: `url(${warehouse}) no-repeat`,
          backgroundSize: "cover",
          opacity: "20%"
        }}
      />

      <Box className="relative w-full h-full flex justify-center items-center z-10">
        <Box className="flex flex-col items-start">
          <Box sx={{ fontWeight: 500, fontSize: "52px", lineHeight: "64px", maxWidth: "600px" }} color="#333333">
            {translate("tradeWithWorld")}
          </Box>

          <Box className="heading-2 mt-4" color="#333333" sx={{ maxWidth: "700px" }}>
            {translate("findPerfectStockProduct")}
          </Box>

          <Box className="mt-12">
            <GlobalSearch width="718px" isBorderRadius={true} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmptySearchAndBuy;